var exports = {
  "pd": "commentBox__XNL6IW",
  "jG": "commentIconButton__gow-xA",
  "X2": "mutedText__ybIJ3Z",
  "NP": "commentHeader__ORteGZ",
  "LV": "authorInfoContainer__9ufy25",
  "jM": "commentAvatar__AUxD9g",
  "fh": "authorName__Tpb5CK",
  "b3": "authorAssociationLabel__ETRfaR",
  "sl": "editingIndicator__AaiC2B",
  "Po": "commentContent__5AZVhq",
  "e6": "deletedCommentText___aZqu8",
  "RW": "reactionContainer__3zE14V",
};

module.exports = exports;
